export default __webpack_public_path__ + "static/media/Vambraces of the Great Impi.5fa742bb.jpg";